import React, { useState, useEffect } from 'react';
import {
  Card, Typography, Button, CardContent, TextField,
  InputAdornment, IconButton, Paper, List, ListItem, ListItemText, Box,
  Dialog, DialogTitle, DialogContent, DialogActions, Rating,
} from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import './Dashboard.css'
import './ResponsiveDocument.css';
import axios from 'axios';
import CloseIcon from "@mui/icons-material/Close";
import GlobalVariable from "../../services/Global";
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from '../SnackbarContext';
import { useLocation } from 'react-router-dom';

const baseApiUrl = GlobalVariable.BASE_API_URL;

const ResponsiveDocument = () => {

  const LOCAL_STORAGE_KEY = "responsive-doc-descriptions";
  const getInitialAccordionItems = () => {
    const storedDescriptions = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");

    return sections.map(header => ({
      ...header,
      paragraphs: [],
      description: storedDescriptions[header.title] || "",
      selectedParagraphs: []
    }));

  };
  const { id } = useParams();
  const [sections, setSections] = useState([]);
  const [accordionItems, setAccordionItems] = useState(getInitialAccordionItems);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isUserTyping, setIsUserTyping] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [popupLoading, setPopupLoading] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [sectionToDelete, setSectionToDelete] = useState(null);
  const [aiLoading, setAiLoading] = useState(null);
  const { showSnackbar } = useSnackbar();
  const [savedSections, setSavedSections] = useState([]);
  const [allSectionsSaved, setAllSectionsSaved] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({}); // Store toggle value per section
  const navigate = useNavigate();

  const location = useLocation();

  const [rfpIssuer, setRfpIssuer] = useState(location.state?.rfpIssuer || sessionStorage.getItem('rfpIssuer') || '');
  const [fileName, setFileName] = useState(
    location.state?.fileName || sessionStorage.getItem('fileName') || ''
  );
  
  useEffect(() => {
    if (rfpIssuer) {
      sessionStorage.setItem('rfpIssuer', rfpIssuer);
    }
    if (fileName) {
      sessionStorage.setItem('fileName', fileName);
    }
  }, [rfpIssuer, fileName]);
  

  const fetchrfpsections = () => {
    setInitialLoading(true);
    axios.get(`${baseApiUrl}/fetch_sections?rfpid=${id}`)
      .then(response => {
        setSections(response.data.sections);
        setInitialLoading(false);

      })
      .catch(error => {
        console.error('Error fetching RFP sections:', error);
      });
  };

  useEffect(() => {
    fetchrfpsections();
  }, [])
  useEffect(() => {
    if (!sections || sections.length === 0) return;
    const storedDescriptions = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
    const newAccordionItems = sections.map(title => ({
      title,
      paragraphs: [],
      description: storedDescriptions[title] || "",
      selectedParagraphs: [],
    }));

    setAccordionItems(newAccordionItems);
  }, [sections]);

  const fetchSuggestions = async (sectionTitle) => {
    try {
      setPopupLoading(true);

      const response = await axios.get(`${baseApiUrl}/section-content-suggestions`, {
        params: {
          rfpid: id,
          section: sectionTitle
        }
      });

      const suggestions = response.data?.suggestions || [];
      const toggle = response.data?.toggle || 'Off'; // Extract toggle value from response

      // Store toggle value for this section
      setSectionToggle(prev => ({
        ...prev,
        [sectionTitle]: toggle
      }));

      // Sort suggestions by star_rating in descending order (highest first)
      const sortedSuggestions = suggestions.sort((a, b) => (b.star_rating || 0) - (a.star_rating || 0));

      const formattedData = sortedSuggestions.map((s) => {
        const cleanContent = s.content;

        const dateMatch = cleanContent.match(
          /\b(?:\d{1,2} (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{4}|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{1,2}, \d{4})\b/i
        );
        const extractedDate = dateMatch ? dateMatch[0] : 'Date not found';
        const utcDate = new Date(s.datetime);
        const istDate = new Date(utcDate.getTime() + (5.5 * 60 * 60 * 1000));
        const formattedIST = istDate.toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });


        return {
          title: sectionTitle,
          text: cleanContent,
          date: extractedDate,
          datetimeIST: formattedIST,
          star_rating: s.star_rating
        };
      });

      setPopupLoading(false);
      return formattedData;
    } catch (err) {
      setPopupLoading(false);
      console.error('Error fetching suggestions:', err);
      return [];
    }
  };


  const handleAccordionClick = async (item, index) => {
    if (selectedIndex === index) {
      setSelectedIndex(null);
      setShowPopup(false);
    } else {

      setSelectedIndex(index);
      setShowPopup(true);

      const suggestions = await fetchSuggestions(item.title);
      const storedDescriptions = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
      const existingDescription = storedDescriptions[item.title];
      
      // Preserve the current description if it exists, otherwise use stored or first suggestion
      const currentDescription = accordionItems[index]?.description || "";
      const defaultDescription = currentDescription || existingDescription || (Array.isArray(suggestions) && suggestions.length > 0 ? suggestions[0].text : "");

      const updatedItems = accordionItems.map((accItem, i) => {
        if (i === index) {
          const selectedParagraphs = [];
          const descriptionToUse = currentDescription || existingDescription || defaultDescription;
          
          if (descriptionToUse && Array.isArray(suggestions)) {
            suggestions.forEach(s => {
              if (descriptionToUse.includes(s.text)) {
                selectedParagraphs.push(s.text);
              }
            });
          } else if (suggestions.length > 0) {
            selectedParagraphs.push(suggestions[0].text);
          }
          return {
            ...accItem,
            paragraphs: suggestions,
            description: descriptionToUse,
            selectedParagraphs,
          };
        } else {
          return {
            ...accItem,
            paragraphs: [],
            selectedParagraphs: [],
          };
        }
      });

      setAccordionItems(updatedItems);
      setSuggestions(suggestions);
      setSearchValue('');
      setIsUserTyping(false);
    }
  };

  const handleParagraphClick = (text) => {
    if (selectedIndex !== null) {
      setAccordionItems(prevItems => {
        const updatedItems = [...prevItems];
        const selectedItem = updatedItems[selectedIndex];
        const selectedTitle = selectedItem.title;
        const newDescription = text;
        updatedItems[selectedIndex] = {
          ...selectedItem,
          description: newDescription,
          selectedParagraphs: [text]
        };
        const updatedStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
        updatedStorage[selectedTitle] = newDescription;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedStorage));
        return updatedItems;
      });
    }
  };


  const handleSavetext = () => {
    const sectionTitle = accordionItems[selectedIndex]?.title;
    const storedDescriptions = JSON.parse(localStorage.getItem("responsive-doc-descriptions") || "{}");

    const description = accordionItems[selectedIndex]?.description || "";

    if (!description.trim()) {
      showSnackbar('Please enter a description before saving.', 'error');
      return;
    }

    const savedata = {
      rfpid: id,
      section_name: sectionTitle,
      content: description,
    };

    axios.post(`${baseApiUrl}/save-section-version`, savedata)
      .then(response => {
        // Keep the description in localStorage so it persists when accordion is reopened
        const updatedStorage = { ...storedDescriptions };
        updatedStorage[sectionTitle] = description; // Keep the saved description in localStorage
        localStorage.setItem("responsive-doc-descriptions", JSON.stringify(updatedStorage));

        setAccordionItems(prevItems => {
          const updatedItems = [...prevItems];
          // Keep the description visible after saving - don't clear it
          updatedItems[selectedIndex] = {
            ...updatedItems[selectedIndex],
            description: description, // Keep the same description value
          };
          showSnackbar('Section saved successfully', 'success');
          setSavedSections(prev => [...prev, sectionTitle]);

          if (savedSections.length + 1 === accordionItems.length) {
            setAllSectionsSaved(true);
          }

          return updatedItems;
        });
      })
      .catch(error => {
        console.error('Error saving section', error);
      });
  };

  const handleDeleteClick = (index) => {
    setSectionToDelete(index);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (sectionToDelete !== null) {
      handleDeleteSection(sectionToDelete);
    }
    setDeleteConfirmOpen(false);
    setSectionToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setSectionToDelete(null);
  };

  const handleDeleteSection = (index) => {
    const sectionTitle = accordionItems[index]?.title;
    
    if (!sectionTitle) {
      showSnackbar('No section selected to delete.', 'error');
      return;
    }

    const deleteData = {
      section: sectionTitle
    };

    axios.delete(`${baseApiUrl}/delete-rfp-section?rfpid=${id}&section_name=${sectionTitle}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    
    })
    .then(response => {
      showSnackbar(`Section '${sectionTitle}' deleted successfully`, 'success');
      
      // Remove the section from the accordion items
      setAccordionItems(prevItems => {
        const updatedItems = prevItems.filter((item, idx) => idx !== index);
        return updatedItems;
      });
      
      // Close the current section if it was the deleted one
      if (selectedIndex === index) {
        setSelectedIndex(null);
        setShowPopup(false);
      }
    })
    .catch(error => {
      console.error('Error deleting section:', error);
      showSnackbar('Error deleting section. Please try again.', 'error');
    });
  };

  const handleresponse = () => {
    navigate(`/preview/response/${id}`, {
      state: { rfpIssuer: rfpIssuer }
    });
  };

  const handleVersionresponse = () => {
    navigate(`/preview/version/${id}`, {
      state: { rfpIssuer: rfpIssuer }
    });
  };

  const handleGenerateContent = async (index) => {
    setAiLoading(index);
    const updated = [...accordionItems];
    const title = updated[index].title;

    try {
      const sectionTitle = accordionItems[selectedIndex]?.title;
      const response = await axios.get(`${baseApiUrl}/generate-content`, {
        params: {
          rfpid: id,
          section: sectionTitle
        }
      });

      const generatedContent = response.data.content;
      updated[index] = {
        ...updated[index],
        description: generatedContent,
        selectedParagraphs: [generatedContent],
      };
      setAccordionItems(updated);
      setAiLoading(null);

      const updatedStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
      updatedStorage[title] = generatedContent;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedStorage));
    } catch (error) {
      console.error('Error generating AI content:', error.response?.data || error.message);
    }
  };

  return (
    <div >
      <Card className="responsive-doc-card">
        <CardContent>
          <Row className="mb-2 align-items-center">
            <Col xs={12} sm={6}>
              <Typography className="fontstylee MicroSoftRFPDetails_heading">
                Response Document  for {rfpIssuer||fileName}
              </Typography>
            </Col>
            <Col xs={12} sm={6} className="d-flex justify-content-end">
              <Button
                className="back-button"
                variant="outlined"
                color="primary"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Col>
          </Row >
          {initialLoading ? (
            <Box
              sx={{
                position: 'absolute',
                top: '60%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1000,
              }}
            >
              <CircularProgress className=' text-primary' />
            </Box>
          ) :


            <Row>
              <Col md={6}>
                <div
                  style={{
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    paddingRight: '8px',
                    paddingLeft: '8px',
                    marginTop: '10px',
                    marginBottom: '10px',

                  }}
                >
                  {accordionItems.map((item, index) => (
                    <Accordion
                      key={index}
                      expanded={selectedIndex === index}
                      onChange={() => handleAccordionClick(item, index)}
                      sx={{
                        mb: 1,
                      }}
                    >
                      <AccordionSummary
                        expandIcon={selectedIndex === index ? null : <ExpandMoreIcon />}
                        aria-controls={`panel${index + 1}-content`}
                        id={`panel${index + 1}-header`}
                      >
                        <Typography
                          component="span"

                          sx={{
                            width: 'calc(100% - 140px)',

                            flexGrow: 1,
                            color: selectedIndex === index ? 'primary.main' : 'text.primary',
                            fontWeight: selectedIndex === index ? 600 : 400,
                            sm: {
                              marginLeft: '5px',
                            }
                          }}
                        >
                          {item.title}
                        </Typography>
                        

                        {selectedIndex === index && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {sectionToggle[item.title] !== 'On' && (
                              <Button
                                className="aibutton"
                                variant="outlined"
                                color="primary"
                                size="small"
                                sx={{ textTransform: 'none' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGenerateContent(index);
                                }}
                              >
                                AI Generator
                              </Button>
                            )}
                            <IconButton
                              color="error"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick(index);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        )}
                      </AccordionSummary>

                      <AccordionDetails>
                        <div style={{ position: 'relative' }}>
                          <textarea
                            ref={(el) => {
                              if (el) {
                                el.style.height = 'auto';
                                el.style.height = `${el.scrollHeight}px`;
                              }
                            }}
                            className="description-textarea"
                            placeholder="Description"
                            value={
                              accordionItems[selectedIndex]?.description
                                ?.replace(/<br\s*\/?>/gi, '\n')
                                .replace(/<\/p>/gi, '\n')
                                .replace(/&nbsp;/g, ' ') 
                                .replace(/<[^>]+>/g, '')||""
                               
                            }
                            
                            disabled={aiLoading === index}
                            onChange={(e) => {
                              const newDescription = e.target.value;
                              if (e.target) {
                                e.target.style.height = 'auto';
                                e.target.style.height = `${e.target.scrollHeight}px`;
                              }

                              setAccordionItems((prevItems) => {
                                const updated = [...prevItems];
                                updated[selectedIndex] = {
                                  ...updated[selectedIndex],
                                  description: newDescription,
                                };

                                const updatedStorage = JSON.parse(
                                  localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
                                );
                                updatedStorage[updated[selectedIndex].title] = newDescription;
                                localStorage.setItem(
                                  LOCAL_STORAGE_KEY,
                                  JSON.stringify(updatedStorage)
                                );

                                return updated;
                              });
                            }}
                          />



                          {aiLoading === index && (
                            <Box
                              position="absolute"
                              top="50%"
                              left="50%"
                              transform="translate(-50%, -50%)"
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <CircularProgress className="text-primary" size={24} />
                            </Box>
                          )}
                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="contained"
                            className="bg-primary text-capitalize rounded-3"
                            onClick={handleSavetext}
                          >
                            Save
                          </Button>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </Col>
              {selectedIndex !== null && showPopup && (
                <Col md={6}>
                  <Paper
                    elevation={3}
                    sx={{
                      width: '100%',
                      maxHeight: '70vh',
                      overflowY: 'auto',
                      padding: {
                        xs: '10px',
                        sm: '15px',
                        md: '20px',
                      },
                      backgroundColor: 'white',
                      boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                      borderRadius: 2,
                      marginBottom: '16px',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography sx={{ marginLeft: 2, fontWeight: 600 }}>Suggestions</Typography>
                      <IconButton
                        onClick={() => {
                          setSearchValue('');
                          setIsUserTyping(false);
                          setShowPopup(false);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>

                    <div style={{ padding: '14px' }}>
                      <TextField
                        fullWidth
                        variant="standard"
                        value={isUserTyping ? searchValue : accordionItems[selectedIndex]?.title || ''}
                        onChange={(e) => {
                          setSearchValue(e.target.value);
                          setIsUserTyping(true);
                        }}
                        placeholder="Search for suggestions"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          // endAdornment: (
                          //   <InputAdornment position="end">
                          //     <IconButton
                          //       onClick={() => {
                          //         setSearchValue('');
                          //         setIsUserTyping(false);
                          //         setShowPopup(false);
                          //       }}
                          //     >
                          //       <CloseIcon />
                          //     </IconButton>
                          //   </InputAdornment>
                          // ),
                          disableUnderline: false,
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            borderBottom: '1px solid #ccc',
                          },
                          '& .MuiInput-underline:before': {
                            borderBottom: '1px solid #ccc !important',
                          },
                          '& .MuiInput-underline:hover:before': {
                            borderBottom: '2px solid #1976d2 !important',
                          },
                          '& .MuiInput-underline:after': {
                            borderBottom: '2px solid #1976d2',
                          },
                        }}
                      />
                    </div>
                    {popupLoading ? (
                      <Box display="flex" justifyContent="center" height="200px" alignItems="center" >
                        <CircularProgress className=' text-primary' />
                      </Box>
                    ) : (

                      <div style={{ overflowY: 'auto', flex: 1 }}>
                        <List sx={{ p: 0 }}>
                          {suggestions.length === 0 ? (
                            <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 2 }}>
                              No suggestions found
                            </Typography>
                          ) : (
                            suggestions
                              .filter((suggestion) =>
                                suggestion.text.toLowerCase().includes(searchValue.toLowerCase())
                              )
                              .map((suggestion, i) => {
                                const descriptionText = accordionItems[selectedIndex]?.description || '';
                                const isSelected = descriptionText.includes(suggestion.text);

                                return (
                                  <ListItem
                                    key={i}
                                    className="list-item"
                                    onClick={() => handleParagraphClick(suggestion.text)}
                                    sx={{
                                      alignItems: 'flex-start',
                                      display: 'flex',
                                      gap: 1.5,
                                    }}
                                  >
                                    <div className="arrow-background hide-on-mobile">
                                      <ArrowBackIcon
                                        className={`${isSelected ? 'selectedIcon' : 'defaultIcon'} hoverIcon`}
                                      />
                                    </div>
                                    <ListItemText
                                      primary={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                          <span
                                            style={{
                                              fontSize: '14px',
                                              display: 'block',
                                              textAlign: 'justify',
                                            }}
                                            className={`${isSelected ? 'selectedText' : 'defaultText'} hoverText`}
                                            dangerouslySetInnerHTML={{ __html: suggestion.text }}
                                          />
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                            Rating:
                                            <Rating
                                              value={suggestion.star_rating || 0}
                                              readOnly
                                              size="small"
                                              precision={0.1}
                                            />
                                            {/* <Typography variant="caption" color="text.secondary">
                                              ({suggestion.star_rating || 0}/5)
                                            </Typography> */}
                                          </Box>
                                        </Box>
                                      }
                                      // secondary={
                                      //   <span style={{ fontSize: '12px', color: 'gray' }}>
                                      //     {suggestion.datetimeIST}
                                      //   </span>
                                      // }
                                    />
                                  
                                  </ListItem>
                                );
                              })
                          )}
                        </List>
                      </div>
                    )}
                  </Paper>
                </Col>
              )}
              <div>
                <Row>
                  <div className="d-flex justify-content-end">
                    <Button
                      variant="contained"
                      className={`text-capitalize rounded-3 me-2 ${allSectionsSaved ? 'bg-primary' : 'bg-disabled'}`}
                      disabled={!allSectionsSaved}
                      onClick={handleVersionresponse}
                    >
                      Version Response
                    </Button>
                    <Button
                      variant="contained"
                      className="bg-primary text-capitalize rounded-3"
                      onClick={handleresponse}
                    >
                      Response
                    </Button>

                  </div>
                </Row>
              </div>
            </Row>

          }

        </CardContent>
      </Card>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this section.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="primary" className='bg-primary' variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ResponsiveDocument;